<template>
  <el-dialog
      :title="titleProp || title"
      :visible.sync="modelValue"
      :close-on-click-modal="false"
      custom-class="custom-dialog-class"
      @open="handleOpen"
      append-to-body
      width="30%"
      :before-close="handleClose"
      @close="closeDialog">
    <template #default >
      <div class="dialog-container" v-loading="loading" >
        <el-form
            :model="form"
            ref="formRef"
            label-width="120px"
            :rules="rules" >
          <el-form-item label="指南名称：" prop="guideName">
            <el-input
                v-model="form.guideName"
                clearable
                placeholder="请输入" />
          </el-form-item>
          <el-form-item label="文章内容：" prop="guideContent">
            <div class="upload-demo-box">
              <el-input
                  v-model="fileName"
                  readonly
                  clearable />
              <el-upload
                  class="upload-demo"
                  :action="action"
                  :headers="headers"
                  :show-file-list="false"
                  :before-upload="beforeUpload"
                  :on-success="handleSuccess"
                  :on-error="handleError"
                  :accept="accept"
                  :limit="1"
                  :file-list="fileList">
                <el-button type="primary" >上 传</el-button>
              </el-upload>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </template>
    <template #footer >
      <div class="dialog-footer">
        <slot :isUpdate="isUpdate" :confirm_handler="confirm_handler" :handleClose="() => handleClose(cancel_handler)" ></slot>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { submitHint } from '../../../common'
export default {
  name: "AuthoritativeGuideAddDialog",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ""
    },
    guideName: {
      type: String,
      default: ""
    },
    guideContent: {
      type: String,
      default: ""
    },
    closeDialog: {
      type: Function,
      default: () => { },
    },
    // 判断是否为审核中心调用
    operType: {
      type: String,
      default: "",
    },
    titleProp: {
      type: String,
      default: "",
    },
    contentId: {
      type: String,
      default: ""
    }
  },

  data() {
    /* 解决审核中心不生效问题 */
    this.handleOpen();
    return {
      loading: false,
      action: `${process.env.VUE_APP_APIURL}guide/upload`,
      accept: ".pdf",
      headers: {
        authorization: this.$store.state.token
      },
      fileList: [],
      form: {
        guideName: "",
        guideContent: "",
      },
      rules: {
        guideName: [
          { required: true, message: '指南名称不能为空', trigger: 'change' }
        ],
        guideContent: [
          { required: true, message: '文章内容不能为空', trigger: 'change' }
        ]
      }
    }
  },
  watch: {

  },
  computed: {
    modelValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    title() {
      let str = "录入指南";
      if (this.id) {
        str = "编辑指南";
      }
      return str;
    },
    fileName() {
      let filename = "";
      if (this.form.guideContent) {
        const lastSlashIndex = this.form.guideContent.lastIndexOf('/');
        filename = this.form.guideContent.substring(lastSlashIndex + 1);
      }
      return filename;
    },
    isUpdate() {
      const rule1 = (this.form.guideName === this.guideName);
      const rule2 = (this.form.guideContent === this.guideContent);
      return rule1 && rule2;
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    handleOpen() {
      this.$nextTick(() => {
        if (this.id) {
          this.form = {
            guideName: this.guideName,
            guideContent: this.guideContent,
          };
        }else {
          this.form = {
            guideName: "",
            guideContent: ""
          };
        }
      })
    },
    beforeUpload(file) {
      let extension = file.name.split(".")[1];
      let extensionList = ["pdf","PDF",];

      if (extensionList.indexOf(extension) < 0) {
        this.$message.warning("只能上传pdf文件");
        return false;
      }
      this.loading = true;
    },
    handleSuccess(res) {
      const { data } = res;
      this.form.guideContent = data;
      this.loading = false;
    },
    handleError() {
      this.$message.error("上传失败");
      this.loading = false;
    },
    confirm_handler() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          console.log('校验成功');
          this.confirm_api_handler();
        } else {
          console.log('校验失败');
          return false;
        }
      });
    },
    async confirm_api_handler() {
      // 审核中心，重新提交复用
      if(this.operType === "reEdit") {
        this.$emit('reEditCommit', { ...this.form, id: this.contentId });
        return;
      }
      try {
        const res = await this.$post("guide/addOrUpdate",{
          ...this.form,
          id: this.id,
          userId: this.$store.state.user_info.userId,
        });
        if (!res) return false;
        submitHint.call(this);
        this.$emit("updateList")
        this.handleClose(this.cancel_handler);
      }catch (e) {
        console.error(`权威指南新增编辑`,e);
      }
    },
    cancel_handler() {
      this.modelValue = false;
    },
    handleClose(done) {
      this.$refs.formRef.resetFields();
      done();
    },
  }
}
</script>

<style scoped lang="scss">
.dialog-container{
  width: 400px;
  margin: 0 auto;
}
.upload-demo-box{
  display: flex;
  .el-button{
    margin-left: 12px;
  }
}
</style>
